import {Reducer} from 'redux';
import initialState from './state';
import {IReduxAction, IReduxRoutesState} from '../../@interfaces';
import {
	ROUTES_CLEAR_API_ROUTES,
	ROUTES_CLEAR_CLIENT_ROUTES,
	ROUTES_SET_API_ROUTES,
	ROUTES_SET_CLIENT_ROUTES
} from './constants';

const reducer: Reducer = (state: IReduxRoutesState = initialState, action: IReduxAction): IReduxRoutesState => {
	switch (action.type) {
		case ROUTES_SET_API_ROUTES:
			return {...state, apiRoutesLoaded: true, apiRoutes: action.payload};

		case ROUTES_CLEAR_API_ROUTES:
			return {...state, apiRoutesLoaded: false};

		case ROUTES_SET_CLIENT_ROUTES:
			return {...state, clientRoutesLoaded: true, clientRoutes: action.payload};

		case ROUTES_CLEAR_CLIENT_ROUTES:
			return {...state, clientRoutesLoaded: false};
	}

	return state;
};

export default reducer;
